import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Home } from 'lucide-react';

const navLinks = [
  { label: 'Templates', to: '/freelance-contract-template' },
  { label: 'Contractvoorbeelden', to: '/freelance-contract-voorbeeld' },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 no-underline flex-shrink-0">
            <div
              className="flex items-center justify-center rounded-full flex-shrink-0"
              style={{ backgroundColor: '#2F4E6F', width: '36px', height: '36px', padding: '6px' }}
            >
              <svg width="24" height="24" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M25 15 C25 12 27 10 30 10 L55 10 C72 10 85 23 85 40 C85 57 72 70 55 70 L40 70 L40 85 C40 88 38 90 35 90 L30 90 C27 90 25 88 25 85 L25 15 Z M40 25 L40 55 L55 55 C63.284 55 70 48.284 70 40 C70 31.716 63.284 25 55 25 L40 25 Z"
                  fill="#FF8C00"
                  fillRule="evenodd"
                />
              </svg>
            </div>
            <span className="text-lg font-semibold tracking-tight text-gray-900">
              PACTORAE
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="p-2 text-gray-600 hover:text-gray-900 rounded-md hover:bg-gray-50 transition-colors no-underline flex items-center"
              aria-label="Home"
            >
              <Home size={18} />
            </Link>
            {navLinks?.map((link) => (
              <Link
                key={link?.label}
                to={link?.to}
                className="px-3 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 rounded-md hover:bg-gray-50 transition-colors no-underline whitespace-nowrap"
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* CTA + Mobile Toggle */}
          <div className="flex items-center gap-3">
            <Link
              to="/contract-generator"
              className="hidden sm:inline-flex items-center px-4 py-2 text-sm font-semibold text-white rounded-lg transition-colors no-underline flex-shrink-0"
              style={{ backgroundColor: '#FF8C00' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e07b00'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#FF8C00'}
            >
              Start gratis
            </Link>

            {/* Hamburger */}
            <button
              className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Dropdown */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <nav className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-3 py-2.5 text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors no-underline flex items-center gap-2"
              onClick={() => setMobileOpen(false)}
            >
              <Home size={16} />
              Home
            </Link>
            {navLinks?.map((link) => (
              <Link
                key={link?.label}
                to={link?.to}
                className="px-3 py-2.5 text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors no-underline"
                onClick={() => setMobileOpen(false)}
              >
                {link?.label}
              </Link>
            ))}
            <div className="pt-2 pb-1">
              <Link
                to="/contract-generator"
                className="flex items-center justify-center w-full px-4 py-2.5 text-sm font-semibold text-white rounded-lg transition-colors no-underline"
                style={{ backgroundColor: '#FF8C00' }}
                onClick={() => setMobileOpen(false)}
              >
                Start gratis
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;